import { Injectable, inject, OnDestroy } from '@angular/core';
import { MockService } from '../../mocks/mock.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { RoleService } from './role.service';
import { getMockedUserId } from '../../mocks/data/auth/mocked-auth';

/**
 * Mock role service for development.
 * Implements RoleService using MockService to simulate roles.
 */
@Injectable()
export class MockRoleService extends RoleService implements OnDestroy {
  private mockService = inject(MockService);
  private mockModeSubscription?: Subscription;

  override readonly userRoles$ = new BehaviorSubject<string[]>([]);

  constructor() {
    super();
    this.setupMockModeListener();
  }

  private setupMockModeListener(): void {
    this.mockModeSubscription = this.mockService.getAuthMockMode$().subscribe(() => {
      this.updateRolesFromToken();
    });
  }

  override updateRolesFromToken(): void {
    const roles = this.mockService.getMockedUserRoles();
    this.userRoles$.next(roles);
  }

  override getUserRoles$(): BehaviorSubject<string[]> {
    return this.userRoles$;
  }

  override getCallerUserId(): string {
    return getMockedUserId();
  }

  ngOnDestroy(): void {
    this.mockModeSubscription?.unsubscribe();
  }
}
